import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns true if url is a fake/invalid blob URL that should not be fetched
 * (e.g. legacy "blob:${momentId}" stored in DB). Real blob URLs from
 * createObjectURL look like "blob:https://origin/uuid".
 */
export function isInvalidBlobUrl(url: string): boolean {
  if (!url.startsWith("blob:")) return false;
  const rest = url.slice(5);
  return /^[a-f0-9-]{36}$/i.test(rest) && rest.includes("-");
}
